<ng-container *ngIf="data">
  <div class="rte">
    <h2 class="map-panel__title" *ngIf="data.title?.value">{{ data.title.value }}</h2>
    <div class="map-panel__description" *ngIf="data.description?.value" [innerHTML]="data.description.value"></div>
  </div>
  <google-map #map height="500px" width="100%" *ngIf="showMap">
    <map-marker *ngFor="let marker of markers" [position]="marker.location"></map-marker>
  </google-map>
</ng-container>
